module.exports = __webpack_public_path__ + "img/Broadsign-logo.3fde2910.png";